var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 200.093H0V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828L512 200.093z",
    fill: "#73af00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.725H8.828A8.829 8.829 0 0 1 0 414.897V311.909h512v102.988a8.828 8.828 0 0 1-8.828 8.828z",
    fill: "#ff4b55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M0 200.091h512v111.81H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M361.945 256.099c0 58.426-47.435 105.945-105.945 105.945s-105.945-47.519-105.945-105.945c0-58.594 47.435-106.029 105.945-106.029s105.945 47.435 105.945 106.029z",
    fill: "#4173cd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f2dd30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.42 229.464h61.556l13.929-42.867 3.699 11.498-20.228 62.316-6.026-4.396 6.301-19.362h-49.506l-9.725-7.189zm30.756 94.785l19.025-58.51-36.462-26.551h12.026l52.995 38.473-6.024 4.396-16.509-12.007-15.325 47.181-9.726 7.018zm99.646 0L256 288.062l-36.442 26.464 3.721-11.329 52.952-38.558 2.262 7.102-16.468 11.923 40.057 29.172 3.74 11.413zm30.756-94.785l-49.781 36.274 13.931 42.869-9.724-7.104-20.209-62.316h7.399l6.298 19.448 40.079-29.172h12.006v.001h.001zM256 170.954l19.025 58.51h45.088l-9.745 7.189h-65.487l2.305-7.189h20.418l-15.325-47.096L256 170.954z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.775 340.823h-3.53v-45.912h3.53v45.912zm78.276-56.991l-43.651-14.12 1.1-3.297 43.672 14.12-1.121 3.297zm-160.123 0l-1.1-3.297 43.692-14.12 1.08 3.297-43.672 14.12zm104.361-58.173l-2.877-2.028 26.995-37.12 2.812 2.03-26.93 37.118zm-48.513 0l-27.038-37.118 2.855-2.03 26.973 37.12-2.79 2.028z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEt);
export default __webpack_public_path__ + "static/media/et.13e90d9fe84853c4ae69371b96f077b3.svg";
export { ForwardRef as ReactComponent };